<template>
    <div class="form-designer-component">
        <div class="mcc-page-header">
            <div class="mu-d-flex ">

                <section class="mu-d-flex mu-flex-row">


                    <h1 class="mu-mb-00">Form template details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00" v-if="!isCopy">
                                {{ (isNewTemplate) ? helpTextCreate.title : helpTextEdit.title }}
                                <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                            </p>
                            <p class="mu-mb-00" v-if="isCopy">
                                {{ (isCopy) ? helpTextCopy.title : helpTextEdit.title }}
                                <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>



            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Form templates</a>
                    </li>
                    <li v-if="!isCopy" aria-current="page">{{ (isNewTemplate) ? 'Create new' : templateName }}
                    </li>
                    <li v-if="isCopy" aria-current="page">{{ copyTemplateName == '' ? 'Create new' :
                                copyTemplateName }}</li>

                </ol>
            </nav>

            <div class="relativePosition">
                <div v-if="!fetchCall" class="spinner-overlay zIndex10">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex spinner-text">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>

                </div>

                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mcc-card" v-if="isDataAvailable">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <form novalidate id="formId" @submit.prevent="saveFormTemplate()">


                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                        <label class="mfc-label--required" for="name">Name</label>
                                        <input type="text" id="name" name="name" required="" placeholder="Name"
                                            ref="name" :value="formTemplateData.name" :pattern="nameRegex"
                                            @input="updateName($event)" maxlength="50">


                                    </div>
                                    <div class="mfc-textarea-wrapper mfc-form-input-container  mfc-form-input-wrapper--width">
                                        <label for="description">Description</label>
                                        <textarea id="description" name="description" ref="description"
                                            placeholder="Description" :value="formTemplateData.description"
                                            :pattern="descRegex"
                                            @input="descriptionChanged($event)"
                                            character-count="" maxlength="100"></textarea> <div class="mfc-invalid-feedback"></div>
                                            <div class="mfc-help-text"> 
                                        <span>You have {{ 100 -
                                formTemplateData.description.length }} characters remaining</span>
                                </div>


                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end ">
                                        <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                            <router-link
                                                :to="isCopy ? CONTEXT_PATH + '/design/formTemplates/' + copyId : CONTEXT_PATH + '/design/formTemplates'"
                                                v-if="formTemplateData.id == null || isCopy">
                                                <button type="button"
                                                    class="mcc-button mcc-button--outline mu-mr-05" title="Cancel"
                                                    id="cancelBtn">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span
                                                        class="mcc-button__label">Cancel</span></button>
                                            </router-link>

                                            <button type="button" class="mcc-button mcc-button--soft-danger"
                                                v-if="showCopyDelete"
                                                @click="$refs.deleteFormTemplateDialogRef.show()" title="Delete"
                                                id="deleteBtn">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Delete</span></button>
                                            <button type="button" class="mcc-button mcc-button--outline"
                                                v-if="showCopyDelete" title="Copy" @click="copyFormTemplate()"
                                                id="copyBtn">
                                                <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Copy</span></button>
                                            <button class="mcc-button mcc-button--success" title="Save" id="saveBtn"
                                                type="submit" >
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Save</span></button>

                                        </div>
                                    </div>


                                </form>


                            </div>


                        </div>
                    </div>
                    <div class="mcc-card mu-border-0">
                        <div class="mcc-card__body">
                            <div v-if="showDesigner">
                                <div class="mcc-card ">
                                    <div
                                        class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                        <div>
                                            <h2 class="mcc-card__title">Preview</h2>
                                        </div>
                                        <div class="mu-d-flex">

                                            <button class="mcc-button mcc-button--outline" title="Edit"
                                                id="editFormDesigner" @click="redirectToForm()">
                                                <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Edit</span></button>

                                        </div>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="form-preview-parent py-2">
                                            <fieldset id="fieldSetRenderForm" class="fieldsetContainer" disabled>
                                                <div id="render-canvas"></div>
                                            </fieldset>
                                            <div class="overlay-div"></div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="isDataAvailable" ref="deleteFormTemplateDialogRef"
                id="deleteFormTemplateDialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Delete form template</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteFormTemplateDialogRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                Are you sure you want to delete this template?

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline"
                                @click="$refs.deleteFormTemplateDialogRef.close()">No</button>
                            <button type="submit" class="mcc-button mcc-button--danger"
                                @click="handleDialogClose()">Yes</button>
                        </div>
                    </div>
                </section>
            </dialog>
        </div>
    </div>
</template>


<style scoped></style>

<script>
import TemplateAPI from "../../../services/TemplateAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import constants from "../../../../src/constants";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '@/formvalid.js';;
export default {
    name: "FormTemplateCreate",
    data() {
        return {
            formTemplateData: {
                name: '',
                description: ''
            },
            helpTextCopy: constantMessages.BREADCRUMB_HELP["formtemplates.copy"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["formtemplates.create"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["formtemplates.edit"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            copyObj: {},
            copyId: null,
            isCopy: false,
            templateId: this.$route.params.templateId,
            templateName: '',
            isNewTemplate: false,
            showCopyDelete: false,
            isDataAvailable: false,
            fetchCall: false,
            showDesigner: false,
            copyTemplateName: ''
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;

        if (this.$route.query.copyId != null) {
            self.isCopy = true;
            self.copyId = this.$route.query.copyId;
            self.getFormTemplate(true, this.$route.query.copyId);
        } else if (self.$route.params.templateId != null && self.$route.params.templateId != "new") {
            self.getFormTemplate(false, self.$route.params.templateId);
            self.showDesigner = true;

        } else {
            self.isDataAvailable = true;
            self.fetchCall = true;

        }
        self.isNewTemplate = self.templateId == null || self.templateId == 'new' || self.isCopy;
        self.showCopyDelete = !self.isNewTemplate && !self.isCopy;
    },
    methods: {
        descriptionChanged(e)
        {
            this.formTemplateData.description = e.target.value
            this.$forceUpdate();
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])

            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
            }
            else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.formTemplateData.name = event.target.value;
        },
        getFormTemplate(isCopy, templateId) {
            let self = this;
            TemplateAPI.getTemplateData(templateId).then(response => {
                if (response != null) {

                    if (!isCopy) {
                        self.formTemplateData = response;
                        self.templateName = response.name;
                        if (self.formTemplateData.templateData != null && self.formTemplateData.templateData != "") {
                            window.generatePreview(
                                JSON.parse(self.formTemplateData.templateData),
                                $("#render-canvas"),
                                0
                            );
                        }
                        let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.formTemplate.details"] + " - " + self.templateName;
                        EventBus.$emit("update-pageTitle", pageTitle);
                    } else {
                        self.copyObj.name = response.name;
                        self.copyObj.description = response.description;
                        self.copyObj.templateData = response.templateData;
                        self.formTemplateData = self.copyObj;
                        self.formTemplateData.name = response.name + " - copy";
                        if (self.formTemplateData.name.length > 50) {
                            self.formTemplateData.name = self.formTemplateData.name.substring(0, 50);
                        }

                    }
                }
            }).finally(() => {
                self.isDataAvailable = true;
                self.fetchCall = true;

            });
        },
        saveFormTemplate() {

            let self = this;
            let form = $('#formId')

            if (this.formTemplateData.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
                    {
                        return;
                    }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }                 
            self.fetchCall = false;
            self.formTemplateData.type = "FORM";
            TemplateAPI.saveTemplate(
                self.formTemplateData
            )
                .then(response => {
                    self.isDataAvailable = true;
                    if (response != undefined) {
                        if (response.error) {
                            for (let k in response.messages) {
                                if (k == "name") {
                                    displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.name.classList.add("ms-is-invalid")

                                } else if (k == "description") {
                                    displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.name.classList.add("ms-is-invalid")

                                }
                            }

                        } else {
                            if (self.isNewTemplate) {
                                this.$router.push(this.CONTEXT_PATH +
                                    "/design/formTemplates/" + response.data.id);
                            } else {
                                self.formTemplateData = response.data;
                                self.templateName = self.formTemplateData.name;
                                self.copyTemplateName = self.templateName;
                            }

                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                });
        },

        handleDialogClose() {
            let self = this;
            TemplateAPI.deleteTemplate(self.$route.params.templateId).then(response => {
                if (response != null && response.error == false) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["message.template.formTemplate.delete"]
                    });
                    self.$router.push(
                        self.CONTEXT_PATH + '/design/formTemplates'
                    );
                }
            });

        },
        copyFormTemplate() {
            let self = this;
            self.$router.push(
                self.CONTEXT_PATH + '/design/formTemplates/new?copyId=' + self.formTemplateData.id
            );
        },
        redirectToList() {
            if (this.templateId != null && this.templateId != 0 && this.templateId != "new") {
                localStorage.setItem("emailTemplateList", "emailTemplateList");
            }

            this.$router.push(
                this.CONTEXT_PATH + '/design/formTemplates'
            );
        },
        redirectToForm() {
            this.$router.push({
                path: `${this.CONTEXT_PATH}/templates/form-template/` +
                    this.formTemplateData.id + '/form-designer'
            });


        }
    },
}
</script>
<style scoped>
.form-designer-component {
  @import "/formdesigner/css/commonStyles.css";
  @import "/formdesigner/styles.css";
}
</style>
<style scoped>
.overlay-div {
    background-color: #e9ecef;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 2;
    opacity: 0.5;
}

.form-preview-parent {
    position: relative;
}

.fieldsetContainer {
    z-index: 1;
}
</style>
